import React from 'react';

import { GetStaticPaths } from 'next';

import { useTranslation } from 'react-i18next';

import HubspotForm from '../../components/common/HubspotForm';
import Layout from '../../components/common/Layout';
import Strip from '../../components/common/Strip';
import { TwoColumnForm } from '../../components/form';
import { useFormsStaticPaths, useItems } from '../../hooks';
import { SINGLE_FORM } from '../../queries';
import { withTranslation } from '../../translation';

const FormPage = ({ pageData, slug }: any) => {
  const { form } = pageData;
  const { t } = useTranslation('forms');

  const content = form[0]?.translations[0];

  const isTwoColumsLayout = ['tca-form', 'contact-form', 'demo-form', 'contact'].includes(slug);
  const formPageCopy = t(slug, { returnObjects: true }) as any;

  const title = content?.title || formPageCopy?.SEO?.title;
  const metaDescription = content?.meta_description || formPageCopy?.SEO?.meta.description;

  return (
    <Layout
      SEO={{
        slug: slug,
        title: title,
        meta: { description: metaDescription },
      }}
    >
      {isTwoColumsLayout ? (
        <Strip variant="white">
          <TwoColumnForm formId={formPageCopy.formId} content={formPageCopy.content} />
        </Strip>
      ) : (
        <Strip variant="blue">
          <HubspotForm formId={content.form_id} />
        </Strip>
      )}
    </Layout>
  );
};

export default FormPage;

export const getStaticPaths: GetStaticPaths = async () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const slugs = await useFormsStaticPaths();

  const paths = [...slugs, 'contact'].map((slug: any) => ({
    params: { slug },
  }));

  return {
    paths,
    fallback: false, // Change to 'blocking' if you want to support dynamic paths
  };
};

export const getStaticProps = withTranslation(async (context) => {
  const slug = context.params?.slug as string;

  if (!slug) {
    return { notFound: true };
  }

  // ✅ Fetch the form post first to get its tags
  const formData = await useItems(SINGLE_FORM, { slug });

  if (!formData || !formData.items?.form) {
    return { notFound: true };
  }

  return {
    props: {
      pageData: formData.items,
      slug,
    },
    revalidate: 10,
  };
});
